module.exports = __webpack_public_path__ + "img/global.6476eecc.webp";